<template>
  <div class="basemenu-search-bar">
    <BaseIcon :name="iconName" class="basemenu-search-bar__icon" />
    <input
      class="basemenu-search-bar__input"
      :class="{
        'has-gray-background': hasGrayBackground,
      }"
      ref="searchInput"
      :name="name"
      id="basemenuSearchBar"
      :type="type"
      :value="value"
      :placeholder="$t('search-bar.placeholder')"
      @input="updateSearch"
      @keydown.enter="searchType"
      autocomplete="off"
    />
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'BaseMenuSearchbar',
  components: {
    BaseIcon,
  },
  props: {
    name: String,
    type: {
      type: String,
      default: 'text',
    },
    iconName: {
      type: String,
      default: 'search',
    },
    hasGrayBackground: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      value: '',
      isDirty: false, // Is used by parent
    };
  },
  methods: {
    searchType(event) {
      if (event.key === 'Enter') {
        this.$emit('search', this.value.trim());
      }
    },
    updateSearch(event) {
      this.isDirty = true;
      this.value = event.target.value;
      this.$emit('search', this.value.trim());
    },
    resetSearchBar() {
      this.isDirty = false;
      this.value = '';
      this.$emit('search', '');
    },
    focusInput() {
      const input = this.$refs.searchInput;
      if (!input) return false;
      input.focus();
      return document.activeElement === input;
    },
    removeFocus() {
      this.$nextTick(() => {
        this.$refs.searchInput.blur();
      });
    },
  },
};
</script>

<style lang="scss">
.basemenu-search-bar {
  position: relative;
  width: 100%;
  background: $color-neutral-pale !important;
  border-radius: $border-radius-large !important;
  border: 1px solid transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  min-height: 36px;
  gap: 8px;

  &__icon {
    flex-grow: 0 1 auto;
    height: 16px;
    width: 16px;
    min-width: 16px;
    max-width: 16px;
    display: flex;
    color: $color-normal-pale;
  }

  &__input {
    display: flex;
    background: transparent;
    outline: none;
    flex-grow: 1 !important;
    align-items: center;
    border: 1px solid transparent;
    min-width: 20px;
  }

  &:focus-within {
    outline: $color-accent solid 1px;
  }
}
</style>
